@let boundData = bound();

<div class="font-body-1 ms-xsmall-y flex flex--middle font-body-medium" data-testid="fare-family-info">
  <span class="bold-type nowrap">{{ passengerCount() }} x</span>
  <fcom-icon [name]="SvgLibraryIcon.RESERVATION" class="icon-medium ms-xxsmall-l flex--shrink0"></fcom-icon>
  <fcom-link
    class="ms-xxsmall-l nowrap overflow-hidden"
    data-testid="fare-family-link"
    [aria]="{ label: 'shoppingCart.viewAllTicketDetailsAria' | finLocalization }"
    [truncate]="true"
    (beforeNavigation)="openFareFamilyDetails.emit()"
    >{{ boundData.fareFamily?.name }}</fcom-link
  >

  @if (price()) {
    <div class="flex-1 flex flex--end ms-small-l nowrap">
      <span class="font-body-1 font-body-medium" data-testid="bound-total-price">
        {{ price() | finPrice }}
      </span>
    </div>
  }
</div>
<div class="ticket-benefits font-body-1 ps-large-l font-body-medium">
  @for (group of benefitGroups(); track group.key) {
    @if (group.routeLabel) {
      <fcom-tag [attr.data-testid]="'benefit-route-tag-' + group.key">{{ group.routeLabel }}</fcom-tag>
    }
    @for (benefit of group.benefits; track $index) {
      <!-- A localized row carries its count inside the copy ("{amount} x Small bag"), so it is passed as a
      title parameter rather than as the row's own count prefix. -->
      <fin-shopping-cart-line-item
        [count]="benefit.title ? benefit.count : undefined"
        [title]="benefit.title"
        [titleKey]="benefit.titleKey"
        [titleParams]="{ amount: benefit.count }"
        testId="benefit-row"
      />
    }
  }
</div>
